import * as React from 'react';
import classnames from 'classnames';

import './Page.scss';
import { Helmet } from 'react-helmet';
import { getPageTitle } from '@moovly/dashboard-global';
interface PageProps {
  header: string;
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  error?: React.ReactNode;
  inPanel?: boolean;
  children: React.ReactNode | React.ReactNode[];
}
const Page: React.FC<PageProps> = ({ title, header, description, children, actions, error, inPanel = true }) => (
  <div className="Page mb-5">
    <Helmet title={getPageTitle(`backoffice.pageHeader.${header}`)} />
    {error}
    {(title || description || actions) && (
      <div className={classnames('Page--Header mb-4 d-flex justify-content-between')}>
        <div>
          {title && <h2>{title}</h2>}
          {description && <p className="m-0">{description}</p>}
        </div>
        {actions && <div className="Page--Actions">{actions}</div>}
      </div>
    )}
    <div className={classnames('Page--Content', { inPanel })}>{children}</div>
  </div>
);

export default Page;
